import { Paper, Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Select, MenuItem, Radio, Button } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { alert } from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";
import UserInfo from "../common/UserInfo";
import { asyncRequest } from "src/services/network";
import TreeSelect from "../lib/tree-select/TreeSelect";

const TitleDialog = ({ open, onClose, onUpdate, user }) => {
  const [form, setForm] = useState({
    orgId: "",
  });

  const [categoryTree, setCategoryTree] = useState([]);

  useEffect(() => {
    getCategories(true);
  }, []);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function getCategories() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/user/org/all",
    });

    setCategoryTree(data);
  }

  async function handleConfirm() {
    if (!form.orgId) return alert("数额不能为空");
    // console.log(form)
    // return;

    const { msg } = await asyncRequest({
      path: "/user/staff/edit",
      data: {
        uid: user.uid,
        ...form,
      },
    });

    alert(msg, "success");
    onUpdate();
  }

  return (
    <FormDialog title="员工职位" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户">
        <UserInfo {...user} />
      </FormItem>

      <FormItem title="职位">
        <TreeSelect
          data={categoryTree}
          value={form.orgId}
          // maxLevel={action === "add" ? row.level : row.level - 1}
          onChange={v => handleIptChange("orgId", v)}
          topLabel="顶级菜单"
        />
      </FormItem>
    </FormDialog>
  );
};

export default TitleDialog;
